<template>
  <v-dialog v-model="value" persistent max-width="400px">
    <v-card class="data-aviso">
      <v-card-title class="subheading">
        <v-flex xs12>
          <v-icon large class="accent--text">error_outline</v-icon>
        </v-flex>
        <v-flex xs12 mb-3 class="text-xs-center">
          <span v-html="pTextAvisoCambioEmpresa"></span>
        </v-flex>
      </v-card-title>
      <v-card-actions pt-4>
        <v-spacer></v-spacer>
        <v-btn class="datPrimaryBtn" @click="fCambiarEmpresa()">{{this.$t('cambiar')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="datPrimaryBtn" @click="fCerrarModal()">{{this.$t('cancelar')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

// Mixins
import mxLogin from '@/mixins/globals/mx-login'

export default {

  name: 'ShpCambioEmpresaDialog',
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    pTextAvisoCambioEmpresa: {
      type: String,
      required: false
    },
    pEmpresaERP: {
      type: Number,
      required: false
    },
    pEmpresaInformes: {
      type: Number,
      required: false
    }
  },

  mixins: [mxLogin],

  data () {
    return {
    }
  },
  methods: {
    fCerrarModal () {
      this.$emit('cerrar')
    }

  }

}
</script>


// WEBPACK FOOTER //
// src/components/Dialogs/ShpCambioEmpresaDialog.vue